var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGhs04 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "GASSER 04",
  viewBox: "0 0 567 566.95",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.31 289.54 289.48 553.7l264.21-264.21q-132.15-132-264.17-264.12Z",
  style: {
    fill: "#fff"
  },
  transform: "translate(-6 -6.06)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.73 147.8 6 289.54l141.74 141.74L289.48 573l141.76-141.75L573 289.49 431.29 147.78C353.35 69.84 289.55 6.06 289.52 6.06S225.69 69.85 147.73 147.8m261.1 22.43 119.26 119.26L408.78 408.8 289.47 528.12 170.21 408.8 51 289.47l119.22-119.25C235.82 104.63 289.49 51 289.52 51s53.72 53.64 119.31 119.23",
  style: {
    fill: "red"
  },
  transform: "translate(-6 -6.06)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M344.28 224.18a12 12 0 0 0-2 .12c-1 .18-185.11 49.62-185.77 49.88-5.22 2.05-8.72 7.74-9.78 15.9a46 46 0 0 0-.23 6.61 44 44 0 0 0 1.33 8.9c3.12 12.67 11 22.62 19.43 24.52a15.8 15.8 0 0 0 4.28.1c.83-.15 183.32-49.08 185.17-49.66 3.53-1.09 6.18-3.55 8.13-7.52a26.3 26.3 0 0 0 2.3-7.46 11.5 11.5 0 0 1 1.88-5.1 10.83 10.83 0 0 1 5.73-4.25c.36-.11 9.47-2.55 20.23-5.43s19.79-5.37 20.09-5.5c4.35-2 5.93-8.35 3.42-13.71a10 10 0 0 0-6.53-5.68 8.3 8.3 0 0 0-3.17 0l-19.94 5.33a5661 5661 0 0 1-19.71 5.28 12 12 0 0 1-2.17.12 8.7 8.7 0 0 1-4-.72 11.8 11.8 0 0 1-4.85-3.86 24.4 24.4 0 0 0-8.11-6.62 15 15 0 0 0-3.62-1.18 14 14 0 0 0-2.11-.07"
})));
export default SvgGhs04;